export class EksNamespaceRestoreDestination {
    's3Bucket';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "s3Bucket",
            "baseName": "s3Bucket",
            "type": "S3RestoreTarget",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return EksNamespaceRestoreDestination.attributeTypeMap;
    }
    constructor() {
    }
}
